import { useEffect, useRef, useState } from "react";
import '../App.css';
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  FiHeart,
  FiShuffle,
  FiSearch
} from "react-icons/fi";
import "./ShopAll.css"
function ShopAll(){
    const navigate = useNavigate();
  const [products, setProducts] = useState([]);
const [loading, setLoading] = useState(true);
const sectionRef = useRef(null);
const [show, setShow] = useState(false);
const [cartProducts, setCartProducts] = useState([]);
const [quickViewProduct, setQuickViewProduct] = useState(null);
const [showQuickView, setShowQuickView] = useState(false);
const [wishlistProducts, setWishlistProducts] = useState([]);
const [categories, setCategories] = useState([]);
const [selectedCategory, setSelectedCategory] = useState("all");
const [showCategory, setShowCategory] = useState(false);
const [compareProducts, setCompareProducts] = useState([]);
const [compareCount, setCompareCount] = useState(0);
const [availability,setAvailability]=useState("all");
const [selectedCardVariants, setSelectedCardVariants] = useState({});
const categoryDropdownRef = useRef(null);
const sortDropdownRef = useRef(null);
const [maxPrice,setMaxPrice]=useState(10000);
const [sort,setSort]=useState("featured");
const highestPrice =
  products.length > 0
    ? Math.max(...products.map((p) => p.price))
    : 0;

const [showAvail,setShowAvail] = useState(false);
const [showPrice,setShowPrice] = useState(false);
const [showSort,setShowSort] = useState(false);

const [showCartPopup, setShowCartPopup] = useState(false);
const [selectedProduct, setSelectedProduct] = useState(null);
const [minPrice, setMinPrice] = useState(0);
const [addingId, setAddingId] = useState(null);
let filtered = [...products]; // always show all by default

const location = useLocation();
const params = new URLSearchParams(location.search);
const rawSearchQuery = params.get("search") || "";
const searchQuery = rawSearchQuery.toLowerCase();
const [searchInput, setSearchInput] = useState("");
const handleSortChange = (value) => {
  setSort(value);
  setShowSort(false);
};
const shopSearchSuggestions =
  searchInput.trim() !== ""
    ? products
        .filter((item) =>
          item.name.toLowerCase().includes(searchInput.toLowerCase())
        )
        .slice(0, 6)
    : [];
useEffect(() => {
  setSearchInput(rawSearchQuery);
}, [rawSearchQuery]);
useEffect(() => {
  const handleOutsideClick = (event) => {
    if (
      categoryDropdownRef.current &&
      !categoryDropdownRef.current.contains(event.target)
    ) {
      setShowCategory(false);
    }

    if (
      sortDropdownRef.current &&
      !sortDropdownRef.current.contains(event.target)
    ) {
      setShowSort(false);
    }
  };

  document.addEventListener("mousedown", handleOutsideClick);

  return () => {
    document.removeEventListener("mousedown", handleOutsideClick);
  };
}, []);
const categoryQuery = params.get("category") || "all";
const getUserGuestPayload = (createGuest = false) => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");
  const userId = storedUser?.id || "";

  let guestId = localStorage.getItem("guest_id") || "";

  if (!userId && createGuest && !guestId) {
    guestId = `guest_${Date.now()}`;
    localStorage.setItem("guest_id", guestId);
  }

  return userId
    ? { user_id: userId, guest_id: "" }
    : { guest_id: guestId, user_id: "" };
};
const fetchCompare = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/compareList",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("Compare Data:", data);

    if (data.status) {
      const ids = data.data.map((item) => Number(item.product_id));

      setCompareProducts(ids);
      setCompareCount(data.total_products);
    } else {
      setCompareProducts([]);
      setCompareCount(0);
    }
  } catch (error) {
    console.error("Compare fetch failed:", error);
  }
};
const handleAddToCompare = async (item) => {
  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(item.id),
    };

    console.log("COMPARE PAYLOAD:", payload);

    const res = await fetch(
      "https://aethearia.store/superadmin/api/addToCompare",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("COMPARE RESPONSE:", data);

    if (data.status) {
      setCompareCount(data.compare_count);
      await fetchCompare();
    } else {
      alert(data.message || "Unable to add compare");
    }
  } catch (error) {
    console.log("Compare Error:", error);
  }
};

const formatProducts = (data) => {
  const heroBase = "https://aethearia.store/superadmin/uploads/products/Hero/";
  const variantBase = "https://aethearia.store/superadmin/uploads/products/Varient/";

  return data.map((item, index) => {
    const variants = (item.variants || []).map((variant) => {
      const price = Number(variant.price || 0);
      const offerPrice = Number(variant.offer_price || 0);

      return {
        id: Number(variant.id),
        product_id: Number(variant.product_id),
        set_of: variant.set_of,
        label:
          Number(variant.set_of) === 1
            ? "Single"
            : `Set of ${variant.set_of}`,
        price,
        offerPrice,
        img: variant.variant_image
          ? variantBase + variant.variant_image
          : heroBase + item.hero_image,
        stock: Number(variant.stock || 0) > 0,
      };
    });

  const firstVariant =
  variants.length > 0
    ? variants[0]
    : {
        id: Number(item.variant_id),
        product_id: Number(item.id),
        label: "Single",
        price: Number(item.price || 0),
        offerPrice: Number(item.offer_price || 0),
        img: item.variant_image
          ? variantBase + item.variant_image
          : heroBase + item.hero_image,
        stock: item.launch_status === "active",
      };

return {
  id: Number(item.id),
  name: item.product_name,
  slug: item.product_slug,
    // Main image = Hero image
  img: item.hero_image
    ? heroBase + item.hero_image
    : firstVariant.img,

  // Hover image = Variant image
  hoverImg: firstVariant.img,
  price: firstVariant.price,
  offerPrice: firstVariant.offerPrice,
  sku: item.sku,
  short_description: item.short_description,
  catname: item.catname,
  stock: item.launch_status === "active",
  created: index + 1,
  variants:
    variants.length > 0
      ? variants
      : [firstVariant],
};
  });
};
useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await fetch(
        "https://aethearia.store/superadmin/api/categories"
      );

      const data = await res.json();

      if (data.status) {
        setCategories(data.data || []);
      }
    } catch (error) {
      console.error("Category fetch error:", error);
    }
  };

  fetchCategories();
}, []);



const handleCategoryFilter = (category) => {
  setSelectedCategory(category.catslug);
  setShowCategory(false);

  if (category.catslug === "all") {
    navigate("/shop-all");
  } else {
    navigate(`/shop-all?category=${category.catslug}`);
  }
};
useEffect(() => {
  const fetchProductsByCategory = async () => {
    try {
      setLoading(true);

      let apiUrl = "https://aethearia.store/superadmin/api/products-list";

      if (categoryQuery !== "all") {
        apiUrl = `https://aethearia.store/superadmin/api/category-products/${categoryQuery}`;
      }

      const response = await fetch(apiUrl);
      const result = await response.json();

      if (result.status) {
        setProducts(formatProducts(result.data || []));
      } else {
        setProducts([]);
      }

      setSelectedCategory(categoryQuery);
      setMinPrice(0);
    } catch (error) {
      console.error("Error fetching category products:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchProductsByCategory();
}, [categoryQuery]);
const fetchWishlist = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/wishlist-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    console.log("Wishlist Data:", data);

    if (data.status) {
      const ids = data.data.map((item) =>
        Number(item.product_id || item.id)
      );

      setWishlistProducts(ids);
    } else {
      setWishlistProducts([]);
    }
  } catch (err) {
    console.error("Wishlist fetch failed:", err);
  }
};

const handleAddToWishlist = async (item) => {
  if (isInWishlist(item.id)) return;

  const oldWishlist = [...wishlistProducts];
  const updatedWishlist = [...wishlistProducts, Number(item.id)];

  // instant UI update
  setWishlistProducts(updatedWishlist);

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        wishlistCount: updatedWishlist.length,
      },
    })
  );

  try {
    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(item.id),
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-wishlist",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      await fetchWishlist();

      setTimeout(() => {
        window.dispatchEvent(new Event("cartWishlistUpdated"));
      }, 300);
    } else {
      setWishlistProducts(oldWishlist);

      window.dispatchEvent(
        new CustomEvent("cartWishlistUpdated", {
          detail: {
            wishlistCount: oldWishlist.length,
          },
        })
      );

      alert(data.message || "Failed to add wishlist");
    }
  } catch (err) {
    console.error("Wishlist Error:", err);

    setWishlistProducts(oldWishlist);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          wishlistCount: oldWishlist.length,
        },
      })
    );
  }
};
const fetchCart = async () => {
  try {
    const payload = getUserGuestPayload();

    if (!payload.user_id && !payload.guest_id) return;

    const res = await fetch(
      "https://aethearia.store/superadmin/api/cart-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (data.status) {
      setCartProducts(data.data || []);
    } else {
      setCartProducts([]);
    }
  } catch (err) {
    console.error("Cart fetch failed:", err);
  }
};
useEffect(() => {

  fetchCart();
  fetchWishlist();
  fetchCompare();

}, []);
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setShow(true);
      }
    },
    { threshold: 0.15 }
  );

  if (sectionRef.current) observer.observe(sectionRef.current);

  return () => {
    if (sectionRef.current) observer.unobserve(sectionRef.current);
  };
}, []);

useEffect(() => {
  if (products.length > 0) {
    const highest = Math.max(...products.map(p => p.price));
    setMaxPrice(highest);
  }
}, [products]);



const handleAddToCart = async (item) => {
  const selectedVariant = getSelectedVariant(item);

  if (!selectedVariant?.id) {
    alert("Variant not found");
    return;
  }

  const oldCart = [...cartProducts];

  const updatedCart = [
    ...cartProducts,
    {
      product_id: Number(item.id),
      variant_id: Number(selectedVariant.id),
    },
  ];

  // instant UI update
  setCartProducts(updatedCart);

  // instant header count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        cartCount: updatedCart.length,
      },
    })
  );

  try {
    setAddingId(`${item.id}-${selectedVariant.id}`);

    const payload = {
      ...getUserGuestPayload(true),
      product_id: Number(item.id),
      variant_id: Number(selectedVariant.id),
      quantity: 1,
    };

    const res = await fetch(
      "https://aethearia.store/superadmin/api/add-to-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (!data.status) {
      throw new Error(data.message || "Invalid request data");
    }

    await fetchCart();

    setTimeout(() => {
      window.dispatchEvent(new Event("cartWishlistUpdated"));
    }, 300);

    setSelectedProduct({
      ...item,
      img: selectedVariant.img,
      price: selectedVariant.price,
      offerPrice: selectedVariant.offerPrice,
      variantLabel: selectedVariant.label,
    });

    setShowCartPopup(true);
  } catch (err) {
    console.error("Add to cart failed:", err.message);

    // rollback if API failed
    setCartProducts(oldCart);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          cartCount: oldCart.length,
        },
      })
    );
  } finally {
    setAddingId(null);
  }
};
// 🔍 ONLY filter if searchQuery exists AND not empty
if (searchQuery && searchQuery.trim() !== "") {
  const q = searchQuery.toLowerCase();

  filtered = filtered.filter(p =>
    p.name.toLowerCase().includes(q)
  );
}

/* availability */
if (availability === "in") {
  filtered = filtered.filter(p => p.stock);
}

if (availability === "out") {
  filtered = filtered.filter(p => !p.stock);
}

/* price */
filtered = filtered.filter(
  p => p.price >= minPrice && p.price <= maxPrice
);

/* sorting */
if (sort === "az") {
  filtered.sort((a, b) => a.name.localeCompare(b.name));
}

if (sort === "za") {
  filtered.sort((a, b) => b.name.localeCompare(a.name));
}

if (sort === "new") {
  filtered.sort((a, b) => b.created - a.created);
}

if (sort === "old") {
  filtered.sort((a, b) => a.created - b.created);
}
const isInCart = (productId, variantId) => {
  return cartProducts.some(
    (cartItem) =>
      Number(cartItem.product_id) === Number(productId) &&
      Number(cartItem.variant_id || cartItem.varient_id) === Number(variantId)
  );
};
const isInWishlist = (productId) => {
  return wishlistProducts.includes(Number(productId));
};
const isInCompare = (productId) => {
  return compareProducts.includes(Number(productId));
};
const getSelectedVariant = (item) => {
  return selectedCardVariants[item.id] || item.variants?.[0] || null;
};
  // 👇 ADD IT HERE
  if (loading) {
    return (
      <>
        <Header />
        <div
          style={{
            marginTop: "180px",
            textAlign: "center",
            padding: "50px",
          }}
        >
          Loading products...
        </div>
        <Footer />
      </>
    );
  }

  const hasSearch = searchQuery && searchQuery.trim() !== "";

  console.log("products", products);
console.log("filtered", filtered);
const currentCategory =
  categories.find(
    (cat) => cat.catslug === selectedCategory
  ) || null;

const currentCategoryName =
  selectedCategory === "all"
    ? "Shop All"
    : currentCategory?.catname || "Shop All";

const currentCategorySubtitle =
  selectedCategory === "all"
    ? "Conscious rituals, adornments and sacred objects"
    : currentCategory?.cat_title || "";
return(
<>
<Header style={{background: 'black'}}/>
{/* {searchQuery && (
  <div style={{ marginBottom: "20px", textAlign: "center" }}>
    <h2>
      Search results for: <span>"{searchQuery}"</span>
    </h2>
  </div>
)} */}
{searchQuery && (
  <div
    style={{
      textAlign: "center",
      marginBottom: "25px",
    }}
    className="shop-search"
  >
    <h2 className="search-title">Search results</h2>

    {/* INPUT WRAPPER */}
   <div className="shop-search-wrap">
  <input
    type="text"
    placeholder="Search products..."
    value={searchInput}
    onChange={(e) => setSearchInput(e.target.value)}
    className="shop-search-input"
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        navigate(`/shop-all?search=${encodeURIComponent(searchInput)}`);
      }
    }}
  />

  <FiSearch
    className="shop-search-icon"
    onClick={() => {
      navigate(`/shop-all?search=${encodeURIComponent(searchInput)}`);
    }}
  />

  {shopSearchSuggestions.length > 0 && (
    <div className="shop-search-suggestions">
      {shopSearchSuggestions.map((item) => (
        <div
          key={item.id}
          className="shop-suggestion-item"
          onClick={() => {
            setSearchInput(item.name);
            navigate(`/product/${item.slug}`);
          }}
        >
          <img src={item.img} alt={item.name} />

          <div>
            <span>{item.name}</span>
            <small>
              ₹{item.offerPrice > 0 ? item.offerPrice : item.price}
            </small>
          </div>
        </div>
      ))}
    </div>
  )}
</div>
  </div>
)}
<section 
  className={`shop-page ${selectedCategory === "all" ? "all-products-page" : ""}`}
>{!searchQuery && selectedCategory !== "all" && (
  <div className="shop-heading no-search">
    <h1>{currentCategoryName}</h1>

    {currentCategorySubtitle && (
      <p>{currentCategorySubtitle}</p>
    )}
  </div>
)}
<div className="shop-top">

<div className="filter-left">
 {/* Category */}
<div
  className="dropdown-wrap"
  ref={categoryDropdownRef}
>
  <button
    type="button"
    className="filter-trigger"
    onClick={() => {
      setShowCategory((previous) => !previous);
      setShowSort(false);
    }}
  >
    Filter By Category ▼
  </button>

  {showCategory && (
    <div className="dropdown-panel1">
      <button
        type="button"
        onClick={() =>
          handleCategoryFilter({
            catslug: "all",
            catname: "All",
          })
        }
      >
        All Products
      </button>

      {categories.map((cat) => (
        <button
          type="button"
          key={cat.id}
          onClick={() => handleCategoryFilter(cat)}
        >
          {cat.catname}
        </button>
      ))}
    </div>
  )}
</div>
{/* Availability */}
<div className="dropdown-wrap">
  <button
    className="filter-trigger"
    onClick={() => setShowSort(!showSort)}
  >
    Sort By ▼
  </button>

  {showSort && (
    <div className="dropdown-panel">
      <button onClick={() => handleSortChange("featured")}>
        Featured
      </button>

      <button onClick={() => handleSortChange("az")}>
        Alphabetically A-Z
      </button>

      <button onClick={() => handleSortChange("za")}>
        Alphabetically Z-A
      </button>

      <button onClick={() => handleSortChange("old")}>
        Newest First
      </button>

      <button onClick={() => handleSortChange("new")}>
        Oldest First
      </button>
    </div>
  )}
</div>

{/* Price */}
 

</div>



<div className="sort-right">

{/* <div className="dropdown-wrap">
<button
className="filter-trigger"
onClick={()=>setShowSort(!showSort)}
>
Featured ▼
</button>

{showSort && (
<div className="dropdown-panel">
<button onClick={()=>setSort("featured")}>Featured</button>
<button onClick={()=>setSort("az")}>Alphabetically A-Z</button>
<button onClick={()=>setSort("za")}>Alphabetically Z-A</button>
<button onClick={()=>setSort("old")}>Newest First</button>
<button onClick={()=>setSort("new")}>Oldest First</button>
</div>
)}
</div> */}

{/* <span>{filtered.length} Products</span> */}



</div>

</div>

{/* {selectedCategory !== "all" && (
  <p className="active-filter-text">
    {
      categories.find((cat) => cat.catslug === selectedCategory)
        ?.catname
    }
  </p>
)} */}

<div className="shop-grid" ref={sectionRef}>
{filtered.map((item, index) => {
  const selectedVariant = getSelectedVariant(item);
  const alreadyAdded = isInCart(item.id, selectedVariant?.id);
  const addingCurrent = addingId === `${item.id}-${selectedVariant?.id}`;

  return (
<Link
  to={`/product/${item.slug}`}
  className="product-link"
  key={item.id}
>
<div
  className="product-card"
  key={index}
  style={{
     transform: "translateY(0)",
    transition: "all 0.9s cubic-bezier(.22,1,.36,1)",
    transitionDelay: `${index * 0.15}s`
  }}
>
<div className="product-image-wrap">
  <img
    src={item.img}
    alt={item.name}
    className="product-main-img"
  />

  <img
    src={item.hoverImg}
    alt={item.name}
    className="product-hover-img"
    onError={(e) => {
      e.currentTarget.style.display = "none";
    }}
  />

  {/* <img
    src={process.env.PUBLIC_URL + "/images/watermark.png"}
    alt="watermark"
    className="product-watermark-img"
  /> */}

  <div className="product-icons">
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!isInWishlist(item.id)) {
          handleAddToWishlist(item);
        }
      }}
    >
      <FiHeart
        size={18}
        color={isInWishlist(item.id) ? "#e63946" : "#efe8dd"}
        fill={isInWishlist(item.id) ? "#e63946" : "transparent"}
      />
    </button>
  </div>
</div>

<div className="product-info">
<h4>{item.name}</h4>
{/* <h5>{item.catname}</h5> */}
{/* <div className="product-price1">
  {Number(item.offerPrice) > 0 ? (
    <>
      <span
        style={{
          textDecoration: "line-through",
          marginRight: "8px",
          color: "#888",
          textAlign: "center",
        }}
      >
        ₹{Number(item.price).toFixed(2)}
      </span>

      <span>₹{Number(item.offerPrice).toFixed(2)}</span>
    </>
  ) : (
    <>₹{Number(item.price).toFixed(2)}</>
  )}
</div> */}

{item.variants?.length > 1 && (
  <div className="shop-variant-row">
    {item.variants.map((variant) => (
      <button
        key={variant.id}
        type="button"
        className={`shop-variant-btn ${
          selectedVariant?.id === variant.id ? "active" : ""
        }`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          setSelectedCardVariants((prev) => ({
            ...prev,
            [item.id]: variant,
          }));
        }}
      >
        {variant.label}
      </button>
    ))}
  </div>
)}

<div className="product-price1">
  {Number(selectedVariant?.offerPrice) > 0 ? (
    <>
      <span
        style={{
          textDecoration: "line-through",
          marginRight: "8px",
          color: "#888",
          textAlign: "center",
        }}
      >
        ₹{Number(selectedVariant?.price || 0).toFixed(2)}
      </span>

      <span>
        ₹{Number(selectedVariant?.offerPrice || 0).toFixed(2)}
      </span>
    </>
  ) : (
    <>₹{Number(selectedVariant?.price || 0).toFixed(2)}</>
  )}
</div>

<button
  className={`add-cart-btn ${alreadyAdded ? "added" : ""}`}
  disabled={addingCurrent || alreadyAdded}
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!alreadyAdded) {
      handleAddToCart(item);
    }
  }}
>
  {addingCurrent
    ? "Adding..."
    : alreadyAdded
    ? "Added To Cart"
    : "+ Add To Cart"}
</button>

</div>

</div>
</Link>

  );
})}

</div>


</section>
{showCartPopup && selectedProduct && (
  <div className="cart-popup-overlay">

    <div className="cart-popup">

      <button
        className="popup-close"
        onClick={() => setShowCartPopup(false)}
      >
        ✕
      </button>

      <div className="popup-top">
        <span>✓</span>
        <p>Item added to your cart</p>
      </div>

      <div className="popup-product">

        <img src={selectedProduct.img} alt="" />

        <div>
          <h4>{selectedProduct.name}</h4>
          <p>{selectedProduct.catname}</p>
          <span>
            ₹{selectedProduct.offerPrice > 0
              ? selectedProduct.offerPrice
              : selectedProduct.price}
          </span>
        </div>

      </div>

      <button
        className="view-cart-btn"
        onClick={() => navigate("/cart")}
      >
        View cart
      </button>

      <button
        className="checkout-btn"
        onClick={() => navigate("/checkout")}
      >
        Check out
      </button>

      <button
        className="continue-btn"
        onClick={() => setShowCartPopup(false)}
      >
        Continue shopping
      </button>

    </div>

  </div>
)}
{showQuickView && quickViewProduct && (
  <div
    className="quick-view-overlay"
    onClick={() => setShowQuickView(false)}
  >
    <div
      className="quick-view-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="quick-close"
        onClick={() => setShowQuickView(false)}
      >
        ✕
      </button>

      <div className="quick-content">

        <div className="quick-image">
          <img
            src={quickViewProduct.img}
            alt={quickViewProduct.name}
          />
        </div>

        <div className="quick-details">

          <h2>{quickViewProduct.name}</h2>
            <h4 className="description">
            {quickViewProduct.catname}
          </h4>
          <p className="sku">
            SKU ID: {quickViewProduct.sku}
          </p>

          <p className="description">
            {quickViewProduct.short_description}
          </p>

          <div className="price">
            ₹
            {quickViewProduct.offerPrice > 0
              ? quickViewProduct.offerPrice
              : quickViewProduct.price}
          </div>

          <button
            className="view-product-btn"
            onClick={() =>
              navigate(`/product/${quickViewProduct.slug}`)
            }
          >
            View Product
          </button>

        </div>

      </div>
    </div>
  </div>
)}
<Footer/>
</>
)
}

export default ShopAll;